<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <!-- No filter content -->

      <template v-slot:list>
        <ListPane :getListMethod="getRepairCodeListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="false" :show-sorting-tab="false" :itemsPerPage="100" :dialog-trigger="dialogtrigger"
          :dialogItem="editItem" :dialog-method-config="dialogMethodConfig" ref="ListPane" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="setEditItem(item)">
            </ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <v-container class="px-4" v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12">
                  <QTextField v-model="item.Id" :label="$t('servicesystem.common_objects.commonterms.code')"
                    maxlength="50" :rules="[requiredRule]" :externaledit="item.new" :disabled="!item.new">
                  </QTextField>
                </v-col>
                <v-col cols="12" class="mt-3">
                  <QTextField v-model="item.Description" maxlength="200"
                    :label="$t('servicesystem.common_objects.commonterms.description')" :rules="[requiredRule]"
                    externaledit>
                  </QTextField>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ListItem from "@/components/ListItems/RepairCodeListItem.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminRepairCodes",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "RC-",
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createRepairCode',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeRepairCode',
        },
      }
    };
  },

  mounted() { },

  methods: {
    handleadded: (item) => this.$refs.ListPane.handleadded(item),
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem({ new: true }); }
  },
};
</script>